import { Typography } from '@mui/material';
import { BasicConfirmDialog } from 'features/ui/base-dialogs';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;

  handleClose(): void;

  handleConfirm(): void;
}

const ConfirmDeleteQuestionDialog: React.FC<Props> = ({ open, handleClose, handleConfirm }) => {
  const { classes } = useStyles();

  return (
    <BasicConfirmDialog
      open={open}
      title={'Frage löschen'}
      confirmButton={'Ok'}
      cancelButton={'Abbrechen'}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
    >
      <Typography className={classes.text}>
        {'Sind Sie sicher, dass Sie die Frage wirklich unwiderruflich vom allgemeinen Fragenkatalog löschen möchten?'}
      </Typography>
    </BasicConfirmDialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  text: {
    fontSize: theme.typography.pxToRem(13),
    whiteSpace: 'pre-wrap',
  },
}));

export default ConfirmDeleteQuestionDialog;
